module.exports = __webpack_public_path__ + "static/Operator_Panel-36f0b1545d1cd87ea074f14586f6be7e.pdf";